<template>
  <div style="width: 100%">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'MonitorIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/monitor/Index.vue